<aside
  class="bg-gray-900 text-white w-64 h-full fixed top-16 left-0 z-50 transform transition-transform duration-300 ease-in-out"
  [class.-translate-x-full]="!isSidebarOpen"
  [class.translate-x-0]="isSidebarOpen || screenWidth >= 768"
>

  <ul class="p-4 space-y-2">
    <li>
      <a
        routerLink="/dashboard"
        routerLinkActive="bg-gray-700 font-semibold"
        class="block p-3 rounded hover:bg-gray-700"
      >
        Dashboard
      </a>
    </li>
    <li>
      <a
        routerLink="/controllers"
        routerLinkActive="bg-gray-700 font-semibold"
        class="block p-3 rounded hover:bg-gray-700"
      >
        Controllers
      </a>
    </li>
  </ul>
</aside>
